<template>
    <CostsByTagContainer
        :project="selectedProject"
        :month="selectedMonth"
    ></CostsByTagContainer>
</template>
<script>
import store from '@/store'
import CostsByTagStore from '@/modules/CostsByTag/_store'
import CostsByTagContainer from '@/modules/CostsByTag'
import { ref, getCurrentInstance } from '@vue/composition-api'
import useSelectProjectAndGroup from '@/composables/useSelectProjectAndGroup'
import useSelectMonth from '@/composables/useSelectMonth'
const STORE_KEY = '$_costsByTag'

export default {
    components: {
        CostsByTagContainer
    },
    setup () {
        const vm = getCurrentInstance().proxy
        const store = vm.$store
        const {
            selectGroup,
            selectedGroup,
            selectedProject,
            setInitialAccountSelect
        } = useSelectProjectAndGroup()
        const {
            selectedMonth
        } = useSelectMonth()
        if (!selectedProject.value) {
            setInitialAccountSelect()
        }
        if (selectedGroup.value) {
            selectGroup(null)
        }
        const tagKey = ref('user:Name')
        store.dispatch(`${STORE_KEY}/getCostTags`, {
            projectIdx: selectedProject.value.projectIdx,
            month: selectedMonth.value,
            tagKey: tagKey.value
        })
        store.dispatch(`${STORE_KEY}/getTagsAll`)

        return {
            selectedProject,
            selectedMonth
        }
    },
    beforeRouteEnter (to, from, next) {
        if (!(STORE_KEY in store._modules.root._children)) {
            store.registerModule(STORE_KEY, CostsByTagStore)
        }
        next()
    }
}
</script>

<style>

</style>
